import mark from '@/assets/images/field-pro-mark.webp';

import styles from './field-pro-logo.module.scss';

export type FieldProLogoTone = 'onDark' | 'onLight';

export type FieldProLogoProps = {
  /** Which surface the lockup sits on — decides the wordmark's colour. */
  tone?: FieldProLogoTone;
  /** Wordmark font size in px. The emblem and the gap scale with it. */
  size?: number;
  className?: string;
};

/**
 * The FieldPro brand lockup: the Greenway emblem plus the FIELDPRO wordmark.
 *
 * The wordmark is **text, not art** — set in PT Sans Narrow Regular, the brand's condensed face
 * (Figma 232:351318). That is deliberate, and matches Tracking Mobile's `FieldProLogo` widget: it
 * recolours per surface (all white on the dark app bar, two-tone on a light one) and stays crisp
 * at any size, whereas the exported lockup rasterises to a solid block.
 *
 * The DOM text stays cased as "FieldPro" and is uppercased in CSS, so the accessible name and any
 * copied text read as the brand name rather than as shouting.
 *
 * The emblem itself is the real brand asset, taken from the mobile app's transparent `app_logo`.
 */
export function FieldProLogo({ tone = 'onLight', size = 20.625, className }: FieldProLogoProps) {
  return (
    <span
      className={[styles.logo, tone === 'onDark' ? styles.onDark : undefined, className]
        .filter(Boolean)
        .join(' ')}
      style={{ '--logo-size': `${size}px` } as React.CSSProperties}
    >
      <img src={mark} alt="" aria-hidden className={styles.mark} />
      <span className={styles.wordmark}>
        <span className={styles.field}>Field</span>
        <span className={styles.pro}>Pro</span>
      </span>
    </span>
  );
}
